module.exports = __webpack_public_path__ + "static/media/veikk.6036a864.jpg";